import React from "react";
import { Link } from "react-router-dom";
const Sidebar = ({ value, setValue, click, setClick }) => {
  return (
    <>
      <aside
        className={click ? "show-sidebar sidebar" : "sidebar"}
        id="sidebar"
      >
        <div>
          <button
            className="close-btn"
            id="close-btn"
            onClick={() => {
              setClick(!click);
              setValue(!value);
            }}
          >
            <i className="fas fa-times"></i>
          </button>
          <ul className="sidebar-links">
            <li>
              <Link
                to="/"
                id="home"
                className="b"
                onClick={() => {
                  setClick(!click);
                  setValue(!value);
                }}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                id="projects"
                className="b"
                onClick={() => {
                  setClick(!click);
                  setValue(!value);
                }}
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                id="contact"
                className="b"
                onClick={() => {
                  setClick(!click);
                  setValue(!value);
                }}
              >
                Contact
              </Link>
            </li>{" "}
            <li>
              <Link
                to="/about"
                id="about"
                className="b"
                onClick={() => {
                  setClick(!click);
                  setValue(!value);
                }}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/education"
                id="education"
                className="b"
                onClick={() => {
                  setClick(!click);
                  setValue(!value);
                }}
              >
                Education
              </Link>
            </li>
          </ul>
          <ul className="social-icons hero-icons hi1">
            <li>
              <a
                href="https://www.facebook.com/junaid4u.ahmad"
                className="social-icon a"
              >
                <i className="fab fa-facebook"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/juac08"
                className="social-icon a"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="https://github.com/juac08" className="social-icon a">
                <i class="fab fa-github"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com" className="social-icon a">
                <i className="fab fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
